import { HTMLAttributes } from 'react';
import { useTranslate } from '@tolgee/react';
import { DetailItem, priceRender } from './TradeDetailPaymentLazada';
import { formatNumber } from 'utils/numberFormat';

interface TradeDetailPaymentJolectProps extends HTMLAttributes<HTMLElement> {
  trade: Conversation.Trade.Vo;
}

export const TradeDetailPaymentJolect = (props: TradeDetailPaymentJolectProps) => {
  const { trade, className, ...otherProps } = props;
  const { unit, buyerPayment } = trade;

  const { t } = useTranslate();

  console.log('[TradeDetailPaymentJolect] buyerPayment', buyerPayment);

  const total = priceRender(buyerPayment?.buyerTotalAmount, (val) => {
    return (
      <DetailItem key="total">
        <span style={className === 'tradeDetail' ? { fontWeight: 'bold' } : {}}>
          {t('domain.order.payment.field.buyerTotal')}
        </span>
        <div>{`${unit} ${formatNumber(val, '0,0.00')}`}</div>
      </DetailItem>
    );
  });

  const shippingFee = priceRender(buyerPayment?.buyerPaidShippingFee, (val) => {
    return (
      <DetailItem key="shippingFee">
        <span style={className === 'tradeDetail' ? { fontWeight: 'bold' } : {}}>
          {t('domain.order.payment.field.shippingFee')}
        </span>
        <div>{`${unit} ${formatNumber(val, '0,0.00')}`}</div>
      </DetailItem>
    );
  });

  const itemPrice = priceRender(buyerPayment?.itemPrice, (val) => {
    return (
      <DetailItem>
        <dt>{t('domain.order.payment.field.productTotal')}</dt>
        <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
      </DetailItem>
    );
  });

  return total ? (
    <div {...otherProps}>
      {itemPrice}
      {shippingFee}
      {total}
    </div>
  ) : null;
};
